import {BASE_TRACK_API_URL} from '@constants/config'
import {apiRequestWithAuth} from '@helpers/query/apiRequestWithAuth'
import {OnShowError} from '@baseTypes/base'
import {IUserStyle, MenuColor} from '@containers/accountStyle/types'

const URL_USER_STYLE = `${BASE_TRACK_API_URL}/v1/users/current/style`

export const getUserStyleApi = async (
	onError?: OnShowError
): Promise<IUserStyle> => {
	return await apiRequestWithAuth<IUserStyle>({
		url: URL_USER_STYLE,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const updateUserStyleApi = async (
	menuColor: MenuColor | null,
	onError?: OnShowError
): Promise<IUserStyle> => {
	return await apiRequestWithAuth<IUserStyle>({
		url: URL_USER_STYLE,
		options: {
			method: 'PUT',
			body: JSON.stringify({menuColor}),
			headers: {
				'content-type': 'application/json',
			}
		},
		onError,
		hasLogOutOnErrorAuth: false,
	})
}
